<p-toast></p-toast>
<div class="grid">
  <div class="col-12">
    <div class="card dashboardTable">
      <p-toolbar styleClass="mb-4" reflow="true">
        <ng-template pTemplate="left">
          <button pButton pRipple label="{{'ADD_LAND_DETAILS'| translate}}" icon="pi pi-plus" class="p-button-success mr-2"
            (click)="openNew()"></button>
        </ng-template>

        <ng-template pTemplate="right">
          <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
            class="p-button-help"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </ng-template>
      </p-toolbar>

      <p-table #dt [value]="lstFarmerLandModel" [rows]="10" [paginator]="true"
        [globalFilterFields]="['Land_ID','Total_Area','Morabba_No','Killa_No','VillageName']"
        [(selection)]="selectedFarmerLand" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}" [showCurrentPageReport]="true" [loading]="loading"
        responsiveLayout="scroll">

        <ng-template pTemplate="caption">
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">{{'MANAGE_LAND_DETAILS'| translate}}</h5>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                placeholder="{{'SEARCH'| translate}}" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 2rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="Land_ID">{{'LAND_ID'| translate}}
              <p-columnFilter type="text" field="Land_ID" display="menu"></p-columnFilter>
              <p-sortIcon field="Land_ID"></p-sortIcon>
            </th>
            <th pSortableColumn="Total_Area">{{'TOTAL_AREA'| translate}}
              <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
              <p-sortIcon field="Total_Area"></p-sortIcon>
            </th>
            <th pSortableColumn="Morabba_No">{{'MORABBA_NUMBER'| translate}}
              <p-columnFilter type="text" field="Morabba_No" display="menu"></p-columnFilter>
              <p-sortIcon field="Morabba_No"></p-sortIcon>
            </th>
            <th pSortableColumn="Killa_No">{{'KILLA_NUMBER'| translate}}
              <p-columnFilter type="text" field="Killa_No" display="menu"></p-columnFilter>
              <p-sortIcon field="Killa_No"></p-sortIcon>
            </th>
            <!-- <th pSortableColumn="Kanals">Kanals
              <p-columnFilter type="text" field="Kanals" display="menu"></p-columnFilter>
              <p-sortIcon field="kanal"></p-sortIcon>
            </th>
            <th pSortableColumn="Marlas">Marlas
              <p-columnFilter type="text" field="Marlas" display="menu"></p-columnFilter>
              <p-sortIcon field="Marlas"></p-sortIcon>
            </th> -->
            <th pSortableColumn="VillageName">{{'VILLAGE'| translate}}
              <p-columnFilter type="text" field="VillageName" display="menu"></p-columnFilter>
              <p-sortIcon field="VillageName"></p-sortIcon>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr>
            <td>
              <p-tableCheckbox [value]="product"></p-tableCheckbox>
            </td>
            <td>{{product.Land_ID}}</td>
            <td>{{product.Total_Area}}</td>
            <td>{{product.Morabba_No}}</td>
            <td>{{product.Killa_No}}</td>
            <!-- <td>{{product.Kanals}}</td> -->
            <td>{{product.VillageName}}</td>
            <td>
              <div class="flex justify-content-between">
                <div *ngIf="product.IsEdit == 1">
                  <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                    (click)="editProduct(product)"></button>
                </div>
                <div *ngIf="product.IsDelete == 1">
                  <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                    (click)="deleteProduct(product)"></button>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
            {{'IN_TOTAL_THERE_ARE'| translate}} {{lstFarmerLandModel ? lstFarmerLandModel.length : 0 }} {{'LAND_DETAILS_ADDED'| translate}}.
          </div>
        </ng-template>
      </p-table>
    </div>

    <p-dialog [(visible)]="productDialog" (onHide)="hideDialog()"
      [style]="{width: innerWidth < 500 ?'400px' : '730px', height: '70vh'}" header="Land Details" [modal]="true"
      reflow="true" class="p-fluid">
      <ng-template pTemplate="content">
        <form [formGroup]="farmerLandForm">
          <div class="grid p-fluid mt-3">
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <!-- <p-inputNumber [useGrouping]="false" inputId="morabbaNumber" class="form-control"
                  formControlName="morabbaNumber" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.morabbaNumber.errors }"></p-inputNumber> -->
                <input pInputText inputId="morabbaNumber" type="text" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="morabbaNumber" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.morabbaNumber.errors }" />
                <div *ngIf="submitted && f.morabbaNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.morabbaNumber.errors.required">{{'MORABBA_NUMBER_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="morabbaNumber">{{'MORABBA_NUMBER'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <!-- <p-inputNumber [useGrouping]="false" inputId="killaNumber" class="form-control"
                  formControlName="killaNumber" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.killaNumber.errors }"></p-inputNumber> -->
                <input pInputText inputId="killaNumber" type="text" class="form-control" formControlName="killaNumber"[pKeyFilter]="blockSpace"
                  autofocus="" tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.killaNumber.errors }" />
                <div *ngIf="submitted && f.killaNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.killaNumber.errors.required">{{'KILLA_NUMBER_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="killaNumber">{{'KILLA_NUMBER'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input readonly pInputText id="totalArea" class="form-control" type="text" formControlName="totalArea"
                  autofocus="" tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.totalArea.errors }" />
                <div *ngIf="submitted && f.totalArea.errors" class="invalid-feedback">
                  <div *ngIf="f.totalArea.errors.required">{{'TOTAL_AREA_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="totalArea">{{'TOTAL_AREA'| translate}}</label>
              </span>
            </div>

            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input pInputText id="kanals" class="form-control" type="text" formControlName="kanals" autofocus=""
                  tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.kanals.errors }"
                  (keyup)="onKanalsChange()"  maxlength="1" pattern="^([0-1]?[0-8])$"  pKeyFilter="int" 
                  oninput="if(!this.value.match('^[0-8][0-8]*$'))this.value='';"/>
                <div *ngIf="submitted && f.kanals.errors" class="invalid-feedback">
                  <div *ngIf="f.kanals.errors.required">{{'KANNALS_IS_REQUIRED'| translate}}</div>
                  <div *ngIf="f.kanals.errors.max">{{'KANAL_CANNOT_BE_GREATER'| translate}}.</div>
                </div>
                <label for="kanals">{{'AREA_IN_KANALS'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input maxlength="2" pKeyFilter="int" pInputText id="marlas"
                  class="form-control" type="text" formControlName="marlas" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.marlas.errors }" (keyup)="onMarlasChange()"
                  oninput="if(!this.value.match('^([0-9]|1[0-9])$'))this.value='';"/>
                <div *ngIf="submitted && f.marlas.errors" class="invalid-feedback">
                  <div *ngIf="f.marlas.errors.required">{{'MARLAS_IS_REQUIRED'| translate}}</div>
                  <div *ngIf="f.marlas.errors.max">{{'MARLAS_SHOULD_NOT_BE_GREATER'| translate}}</div>
                </div>
                <label for="marlas">{{'AREA_IN_MARLAS'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <p-treeSelect formControlName="cropType" [(ngModel)]="selectedNodes1" [options]="nodes2"
                  [metaKeySelection]="false" selectionMode="checkbox" placeholder="{{'SELECT_CROP_TYPE'| translate}}"></p-treeSelect>

                <div *ngIf="submitted && f.cropType.errors" class="invalid-feedback">
                  <div *ngIf="f.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                </div>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <p-autoComplete formControlName="village" [(ngModel)]="selectedVillage" placeholder="{{'SEARCH_VILLAGE'}}"
                  id="dd" [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
                  (completeMethod)="filterVillage($event)" field="Name"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.village.errors }"></p-autoComplete>

                <div *ngIf="submitted && f.village.errors" class="invalid-feedback">
                  <div *ngIf="f.village.errors.required">{{'VILLAGE_IS_REQUIRED'| translate}}</div>
                </div>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input pInputText id="latitude" class="form-control" type="text" formControlName="latitude" autofocus=""
                  tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.latitude.errors }" />
                <div *ngIf="submitted && f.latitude.errors" class="invalid-feedback">
                  <div *ngIf="f.latitude.errors.required">{{'LATITUDE_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="latitude">{{'LATITUDE'| translate}} </label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input pInputText id="longitude" class="form-control" type="text" formControlName="longitude"
                  autofocus="" tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.longitude.errors }" />
                <div *ngIf="submitted && f.longitude.errors" class="invalid-feedback">
                  <div *ngIf="f.longitude.errors.required">{{'LONGITUDE_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="longitude ">{{'LONGITUDE'| translate}} </label>
              </span>
              <p class="text-message" (click)="setCurrentPosition()">{{'FIND_MY_CURRENT_LOCATION'| translate}}</p>
            </div>

            <div class="field  col-12 md:col-4">
              <label class="mb-3">{{'LEASE_LAND'| translate}}</label>
              <div class="formgrid grid">
                <div class="field-radiobutton col-4">
                  <p-radioButton name="IsSubsidyAvailabe" [value]="true" [(ngModel)]="valRadio"
                    formControlName="IsSubsidyAvailabe" id="IsSubsidyAvailabeYes">
                  </p-radioButton>
                  <label for="IsSubsidyAvailabeYes">{{'YES'| translate}}</label>
                </div>
                <div class="field-radiobutton col-8">
                  <p-radioButton name="IsSubsidyAvailabe" [value]="false" [(ngModel)]="valRadio"
                    formControlName="IsSubsidyAvailabe" id="IsSubsidyAvailabeNo">
                  </p-radioButton>
                  <label for="IsSubsidyAvailabeNo">{{'NO'| translate}}</label>
                </div>
              </div>
            </div>
            <!-- <div class="field col-12 md:col-4">

            </div> -->
            <!-- <div class="field col-12 md:col-4">
              <div class="flex">
                <button pButton pRipple type="button" label="Find my current location"
                  class="p-button-outlined mr-2 mb-2" (click)="setCurrentPosition()">

                </button>
              </div>
            </div> -->
            <div class="field col-12 md:col-4">
              <div class="flex">
                <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerLandLocUpload
                  (uploadHandler)="onUpload($event, 'landdoc_Path', farmerLandLocUpload)" name="myfile[]" mode="basic"
                  [maxFileSize]="5000000" chooseLabel="{{'UPLOAD_DOCUMENTS'| translate}}" [auto]="true">
                </p-fileUpload>
                <p-image *ngIf="f.landdoc_Path.value" [src]="f.landdoc_Path.value" alt="Image" width="60" class="ml-2"
                  iconPos="left"></p-image>
              </div>
              <div *ngIf="submitted && f.landdoc_Path.errors" class="invalid-feedback">
                <div *ngIf="f.landdoc_Path.errors.required">{{'LAND_DOCUMENT_IS_REQUIRED'| translate}}</div>
              </div>
            </div>
            <div class="field col-12 md:col-4" *ngIf="valRadio">
              <div class="flex">
                <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerLeaseDocUpload
                  (uploadHandler)="onUpload($event, 'leaseDoc_Path', farmerLeaseDocUpload)" name="myfile[]" mode="basic"
                  [maxFileSize]="5000000" chooseLabel="{{'UPLOAD_LEASE_DOCUMENTS'| translate}}" [auto]="true">
                </p-fileUpload>
                <p-image *ngIf="f.leaseDoc_Path.value" [src]="f.leaseDoc_Path.value" alt="Image" width="60" class="ml-2"
                  iconPos="left"></p-image>
              </div>
            </div>
          </div>
        </form>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="{{'SAVE' | translate}}" icon="pi pi-check" class="p-button-text" (click)="onSubmit()"></button>
      </ng-template>
    </p-dialog>

    <p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>
  </div>
</div>
